import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import PublicLayout from "sections/PublicLayout";

// App.js had no catch-all route, so every mistyped or stale URL rendered a
// blank white page with the chrome missing entirely.
function NotFound() {
  return (
    <PublicLayout
      eyebrow="Error 404"
      title="We couldn't find that page"
      subtitle="The link may be out of date, or the page may have moved."
    >
      <Container>
        <MKBox py={{ xs: 4, md: 6 }} textAlign="center">
          <MKTypography variant="h4" color="dark" mb={1}>
            Try one of these instead
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={4}>
            If you reached this page from a link on our site, please let us know.
          </MKTypography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <MKButton component={Link} to="/" variant="gradient" color="primary">
              Back to home
            </MKButton>
            <MKButton component={Link} to="/teachers" variant="outlined" color="primary">
              Browse teachers
            </MKButton>
            <MKButton component={Link} to="/contact-us" variant="outlined" color="primary">
              Contact us
            </MKButton>
          </Stack>
        </MKBox>
      </Container>
    </PublicLayout>
  );
}

export default NotFound;
